import React, { Fragment } from "react";
import { toast } from "src/react/components/toast";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addProductToBasket } from "src/redux/signup/actions";
import {
  makeGetIsSignupProductSelected,
  getBasketQuantity,
} from "src/redux/signup/selectors";
import { Button } from "src/react/components/button";
import { Link } from "src/react/components/link";

function getButtonText({ isProductSelected, isProductOutOfStock }) {
  if (isProductOutOfStock) return "Out of stock";

  if (isProductSelected) return "Added to basket";

  return "Add to basket";
}

export function ProductBasketButton({
  sku,
  basketQuantity,
  isProductSelected,
  isProductOutOfStock,
  showBasketLinkInSuccessToast = true,
  addProduct,
  ...rest
}) {
  const isDisabled = isProductSelected || isProductOutOfStock;
  const addToBasketAndNotify = () => {
    toast.success(
      <Fragment>
        Added to basket
        {showBasketLinkInSuccessToast && (
          <Fragment>
            <br />
            <Link to="/signup/basket" data-selector="BasketToast-basketLink">
              View basket ({basketQuantity + 1})
            </Link>
          </Fragment>
        )}
      </Fragment>
    );
    addProduct({ sku });
  };

  return (
    <Button
      data-selector={`ProductBasketButton-${sku}`}
      onClick={addToBasketAndNotify}
      variant="primary"
      disabled={isDisabled}
      style={{
        ...(isDisabled && {
          cursor: "default",
        }),
      }}
      {...rest}
    >
      {getButtonText({ isProductSelected, isProductOutOfStock })}
    </Button>
  );
}

ProductBasketButton.propTypes = {
  sku: PropTypes.string.isRequired,
  basketQuantity: PropTypes.number.isRequired,
  addProduct: PropTypes.func.isRequired,
  isProductSelected: PropTypes.bool.isRequired,
  isProductOutOfStock: PropTypes.bool,
  showBasketLinkInSuccessToast: PropTypes.bool,
};

const mapStateToProps = (state, { sku }) => {
  const getSubscribeIsProductSelected = makeGetIsSignupProductSelected(sku);
  return {
    isProductSelected: getSubscribeIsProductSelected(state),
    basketQuantity: getBasketQuantity(state),
  };
};

const mapDispatchToProps = {
  addProduct: addProductToBasket,
};

const ConnectedProductBasketButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductBasketButton);

ConnectedProductBasketButton.displayName = "ProductBasketButton";

export default ConnectedProductBasketButton;
